import { createContext } from 'react';
import { IConfiguration } from '../../util/Models/ConfigurationModel';

const ConfigurationContext = createContext<IConfiguration | undefined>(undefined);

export default ConfigurationContext;
